(function () {
  'use strict';

  var container = document.getElementById('repair-form-container');
  if (!container) return;

  var form = document.getElementById('repair-request-form');
  var dropZone = document.getElementById('repair-drop-zone');
  var fileInput = document.getElementById('repair-photos');
  var previewsEl = document.getElementById('repair-previews');
  var successEl = document.getElementById('repair-success');
  var errorEl = document.getElementById('repair-error');
  var noOrderCheck = document.getElementById('repair-no-order');
  var orderWrapper = document.getElementById('repair-order-wrapper');
  var ordererFields = document.getElementById('repair-orderer-fields');

  var webhookUrl = container.dataset.webhookUrl || '';
  var maxFiles = parseInt(container.dataset.maxFiles, 10) || 5;
  var maxSizeMb = parseInt(container.dataset.maxSizeMb, 10) || 5;
  var maxSizeBytes = maxSizeMb * 1024 * 1024;

  var selectedFiles = [];
  var photosErrorEl = document.getElementById('repair-photos-error');
  var shrinkAboveBytes = 2 * 1024 * 1024;
  var shrinkMaxSide = 2048;

  // --- No order checkbox: toggle order_number vs orderer name fields ---
  if (noOrderCheck) {
    noOrderCheck.addEventListener('change', function () {
      var orderInput = form.querySelector('[name="order_number"]');
      var ordererFn = form.querySelector('[name="orderer_first_name"]');
      var ordererLn = form.querySelector('[name="orderer_last_name"]');

      if (noOrderCheck.checked) {
        // Hide order number
        if (orderInput) {
          orderInput.removeAttribute('required');
          orderInput.value = '';
        }
        orderWrapper.classList.add('is-hidden');

        // Show orderer name fields
        ordererFields.classList.add('is-visible');
        if (ordererFn) ordererFn.setAttribute('required', '');
        if (ordererLn) ordererLn.setAttribute('required', '');
      } else {
        // Show order number
        if (orderInput) orderInput.setAttribute('required', '');
        orderWrapper.classList.remove('is-hidden');

        // Hide orderer name fields
        ordererFields.classList.remove('is-visible');
        if (ordererFn) {
          ordererFn.removeAttribute('required');
          ordererFn.value = '';
        }
        if (ordererLn) {
          ordererLn.removeAttribute('required');
          ordererLn.value = '';
        }
      }
    });
  }

  // --- Drop zone ---
  dropZone.addEventListener('click', function () {
    fileInput.click();
  });

  dropZone.addEventListener('dragover', function (e) {
    e.preventDefault();
    dropZone.classList.add('is-dragover');
  });

  dropZone.addEventListener('dragleave', function () {
    dropZone.classList.remove('is-dragover');
  });

  dropZone.addEventListener('drop', function (e) {
    e.preventDefault();
    dropZone.classList.remove('is-dragover');
    handleFiles(e.dataTransfer.files);
  });

  fileInput.addEventListener('change', function () {
    handleFiles(fileInput.files);
    fileInput.value = '';
  });

  function isImageFile(file) {
    if (file.type && file.type.startsWith('image/')) return true;
    var ext = (file.name || '').split('.').pop().toLowerCase();
    return ['jpg','jpeg','jfif','png','gif','webp','heic','heif','bmp','tiff','tif','svg'].indexOf(ext) !== -1;
  }

  function isPdfFile(file) {
    return file.type === 'application/pdf' || /\.pdf$/i.test(file.name || '');
  }

  // Une photo de téléphone dépasse souvent 5 Mo : on la réduit ici plutôt que
  // de l'écarter en silence (deux demandes d'octobre 2026 arrivées sans photo).
  function shrinkImage(file) {
    return new Promise(function (resolve, reject) {
      var url = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(url);
        var scale = Math.min(1, shrinkMaxSide / Math.max(img.naturalWidth, img.naturalHeight));
        var canvas = document.createElement('canvas');
        canvas.width = Math.round(img.naturalWidth * scale);
        canvas.height = Math.round(img.naturalHeight * scale);
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        canvas.toBlob(function (blob) {
          if (!blob) { reject(); return; }
          resolve(new File([blob], file.name.replace(/\.[^.]+$/, '') + '.jpg', { type: 'image/jpeg' }));
        }, 'image/jpeg', 0.85);
      };
      img.onerror = function () { URL.revokeObjectURL(url); reject(); };
      img.src = url;
    });
  }

  function handleFiles(fileList) {
    var files = Array.prototype.slice.call(fileList);
    var tooLarge = [];
    var notImage = [];
    if (photosErrorEl) photosErrorEl.style.display = 'none';

    var chain = Promise.resolve();
    files.forEach(function (file) {
      chain = chain.then(function () {
        if (selectedFiles.length >= maxFiles) return;
        if (isPdfFile(file)) {
          if (file.size > maxSizeBytes) { tooLarge.push(file.name); return; }
          selectedFiles.push(file);
          return;
        }
        if (!isImageFile(file)) { notImage.push(file.name); return; }
        if (file.size <= shrinkAboveBytes) { selectedFiles.push(file); return; }
        return shrinkImage(file).then(function (small) {
          if (small.size > maxSizeBytes) { tooLarge.push(file.name); return; }
          selectedFiles.push(small);
        }, function () {
          if (file.size > maxSizeBytes) { tooLarge.push(file.name); return; }
          selectedFiles.push(file);
        });
      });
    });

    chain.then(function () {
      renderPreviews();
      var lines = [];
      if (notImage.length) lines.push((container.dataset.msgNotImage || '') + ' ' + notImage.join(', '));
      if (tooLarge.length) lines.push((container.dataset.msgTooLarge || '') + ' ' + tooLarge.join(', '));
      if (lines.length && photosErrorEl) {
        photosErrorEl.textContent = lines.join(' ');
        photosErrorEl.style.display = 'block';
      }
    });
  }

  function renderPreviews() {
    previewsEl.innerHTML = '';
    selectedFiles.forEach(function (file, idx) {
      var wrapper = document.createElement('div');
      wrapper.className = 'repair-form__preview';

      var img;
      if (isPdfFile(file)) {
        img = document.createElement('span');
        img.className = 'repair-form__preview-pdf';
        img.textContent = 'PDF';
        img.title = file.name;
      } else {
        img = document.createElement('img');
        img.src = URL.createObjectURL(file);
        img.alt = file.name;
      }

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'repair-form__preview-remove';
      btn.textContent = '\u00d7';
      btn.dataset.index = idx;
      btn.addEventListener('click', function () {
        selectedFiles.splice(parseInt(this.dataset.index, 10), 1);
        renderPreviews();
      });

      wrapper.appendChild(img);
      wrapper.appendChild(btn);
      previewsEl.appendChild(wrapper);
    });
  }

  // --- Form submission ---
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    hideMessages();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    if (!webhookUrl) {
      showError('Configuration error. Please contact us.');
      return;
    }

    var firstName = form.querySelector('[name="first_name"]').value.trim();
    var lastName = form.querySelector('[name="last_name"]').value.trim();
    var email = form.querySelector('[name="email"]').value.trim();
    var orderNumber = form.querySelector('[name="order_number"]').value.trim();
    var product = form.querySelector('[name="product"]').value.trim();
    var category = form.querySelector('[name="category"]').value;
    var description = form.querySelector('[name="description"]').value.trim();

    // Build FormData
    var fd = new FormData();
    var storeEl = form.querySelector('[name="store"]');
    fd.append('store', storeEl ? storeEl.value : 'mayuri');
    fd.append('first_name', firstName);
    fd.append('last_name', lastName);
    fd.append('email', email);
    fd.append('product', product);
    fd.append('category', category);
    fd.append('description', description);

    if (noOrderCheck.checked) {
      fd.append('order_number', '');
      var ordererFn = form.querySelector('[name="orderer_first_name"]');
      var ordererLn = form.querySelector('[name="orderer_last_name"]');
      fd.append('orderer_first_name', ordererFn ? ordererFn.value.trim() : '');
      fd.append('orderer_last_name', ordererLn ? ordererLn.value.trim() : '');
    } else {
      fd.append('order_number', orderNumber);
    }

    selectedFiles.forEach(function (file, i) {
      fd.append('photo_' + i, file, file.name);
    });

    // Send
    setLoading(true);

    fetch(webhookUrl, {
      method: 'POST',
      body: fd
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Server error: ' + res.status);
        return res.json().catch(function () { return {}; });
      })
      .then(function () {
        setLoading(false);
        form.style.display = 'none';
        successEl.style.display = 'block';
        window.scrollTo({ top: container.offsetTop - 100, behavior: 'smooth' });
      })
      .catch(function (err) {
        setLoading(false);
        showError(err.message || 'An error occurred. Please try again.');
      });
  });

  function setLoading(on) {
    container.classList.toggle('is-loading', on);
  }

  function showError(msg) {
    // Set the error text inside the banner
    var bannerContent = errorEl.querySelector('.banner__content, p, span');
    if (bannerContent) bannerContent.textContent = msg;
    errorEl.style.display = 'block';
    successEl.style.display = 'none';
  }

  function hideMessages() {
    errorEl.style.display = 'none';
    successEl.style.display = 'none';
  }
})();
